(() => {
  'use strict';

  const SELECTORS = {
    root: 'expert-carousel-component',
    slide: '.expert-carousel__slide',
    quote: '.expert-carousel__quote',
    btnPrev: '.expert-carousel__btn--prev',
    btnNext: '.expert-carousel__btn--next',
    hiddenSlide: 'expert-carousel__slide--hidden',
    hiddenQuote: 'expert-carousel__quote--hidden',
    disabled: 'expert-carousel__btn--disabled',
  };

  class ExpertCarousel {
    constructor(root) {
      this.root = root;
      this.slides = [...root.querySelectorAll(SELECTORS.slide)];
      this.quotes = [...root.querySelectorAll(SELECTORS.quote)];
      this.btnPrev = root.querySelector(SELECTORS.btnPrev);
      this.btnNext = root.querySelector(SELECTORS.btnNext);
      this.current = 0;

      this.onPrev = this.onPrev.bind(this);
      this.onNext = this.onNext.bind(this);

      this.attach();
    }

    attach() {
      this.btnPrev?.addEventListener('click', this.onPrev);
      this.btnNext?.addEventListener('click', this.onNext);
    }

    onPrev() {
      if (this.current > 0) {
        this.goTo(this.current - 1);
      }
    }

    onNext() {
      if (this.current < this.slides.length - 1) {
        this.goTo(this.current + 1);
      }
    }

    goTo(index) {
      // Hide current
      this.slides[this.current]?.classList.add(SELECTORS.hiddenSlide);
      this.quotes[this.current]?.classList.add(SELECTORS.hiddenQuote);

      // Show next
      this.current = index;
      this.slides[this.current]?.classList.remove(SELECTORS.hiddenSlide);
      this.quotes[this.current]?.classList.remove(SELECTORS.hiddenQuote);

      this.updateButtons();
    }

    updateButtons() {
      const isFirst = this.current === 0;
      const isLast = this.current === this.slides.length - 1;

      this.btnPrev?.classList.toggle(SELECTORS.disabled, isFirst);
      this.btnPrev?.setAttribute('aria-disabled', isFirst);

      this.btnNext?.classList.toggle(SELECTORS.disabled, isLast);
      this.btnNext?.setAttribute('aria-disabled', isLast);
    }
  }

  const instances = new Map();

  const mountAll = () => {
    document.querySelectorAll(SELECTORS.root).forEach((root) => {
      if (instances.has(root)) return;
      instances.set(root, new ExpertCarousel(root));
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountAll);
  } else {
    mountAll();
  }
})();
